/**
 * Detect the user's timezone from the browser, falling back to America/Los_Angeles.
 */
export function getUserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch {
    return 'America/Los_Angeles'
  }
}
